import { useTranslation } from 'react-i18next';
import { GradientSpinner } from '@/styles/common';
import { ScLoader } from './styled';

export interface ILoaderProps {
  size?: number;
  color?: string;
  background?: string;
  borderWidth?: number;
  center?: boolean;
  margin?: string;
}

export const Loader = ({ ...props }: ILoaderProps) => {
  const { t } = useTranslation('common');

  return (
    <ScLoader>
      <div>{t('loading')}</div>
      <GradientSpinner {...props} />
    </ScLoader>
  );
};
